var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-avatar"},[_c('avatar',{attrs:{"image":_vm.image,"isTeam":_vm.isTeam,"isMember":_vm.isMember,"width":_vm.width,"clickable":_vm.clickable},on:{"click":_vm.onAvatarClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }